// phoneError — client-side phone check using the same shared schema the API uses, so the message
// is identical. A blank value is never an error (an optional phone is simply omitted).
import type { ZodTypeAny } from "zod";

export function phoneError(schema: ZodTypeAny, value: string): string | null {
  const trimmed = value.trim();
  if (trimmed === "") return null;
  const result = schema.safeParse(trimmed);
  return result.success ? null : (result.error.issues[0]?.message ?? null);
}
